import { render, staticRenderFns } from "./StartseiteDozierende.vue?vue&type=template&id=005925af&"
import script from "./StartseiteDozierende.vue?vue&type=script&lang=js&"
export * from "./StartseiteDozierende.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports